module.exports = __webpack_public_path__ + "frontend/img/icon_check.b55032dc.svg";